/** Available SMS-gate services to use */
export enum SmsGateEnum {
  /** "MainSMS" SMS-gate service */
  MAIN_SMS = 'MAIN_SMS',
}
